import { render, staticRenderFns } from "./ParcelConfirmDialog.vue?vue&type=template&id=6d453703&scoped=true"
import script from "./ParcelConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ParcelConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d453703",
  null
  
)

export default component.exports